import React, { ReactElement } from 'react';
import Text from './ui/text';
import cn from 'classnames';
import { ASSET_URL } from '@lib/constants';
import Image from 'next/image';

interface Props {
  idx: number;
  title: string;
  description: string;
  hideDescription: boolean;
  image: any;
}

export default function FeatureGridItem({
  idx,
  title,
  description,
  hideDescription = false,
  image,
}: Props): ReactElement {
  const renderImage = () => {
    if (image) {
      return (
        <div className="absolute h-12 w-12 top-3 right-3 z-20">
          <Image
            src={
              image
                ? ASSET_URL + '/' + image.filename
                : '/assets/images/telesoft-soc.png'
            }
            loading="lazy"
            alt={image?.alt || ''}
            layout="fill"
            className="object-contain object-center"
          />
        </div>
      );
    }
    return '';
  };
  return (
    <div
      key={idx}
      className={cn(
        `group relative duration-300 p-6 md:p-8 lg:p-12 bg-telesoft col-span-full md:col-span-4 lg:col-span-4 border-heading flex flex-col justify-start items-stretch`
        /*{
          "border-t": border === "top",
          "border-b": border === "bottom",
        } DISABLE UNTIL MORE FLEXIBILITY INTRODUCED IN CMS FOR THIS */
      )}
    >
      {renderImage()}
      <Text
        variant="heading"
        className="text-black"
        style={{ fontSize: '1.25rem' }}
      >
        {title}
      </Text>
      {!hideDescription && (
        <Text variant="body" className="text-black" style={{ margin: 'auto' }}>
          {description}
        </Text>
      )}
    </div>
  );
}
